module.exports = __webpack_public_path__ + "static/media/apple-icon.f93f6411.png";